import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export interface HomeQuickLinkItem {
  label: string;
  path: string;
  icon: React.ElementType;
}

interface HomeQuickLinksProps {
  links: HomeQuickLinkItem[];
  align?: "center" | "start";
}

const HomeQuickLinks: React.FC<HomeQuickLinksProps> = ({
  links,
  align = "center",
}) => {
  if (links.length === 0) return null;

  return (
    <Box sx={{ width: "100%", mt: 2 }}>
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{
          display: "block",
          mb: 1,
          letterSpacing: "0.08em",
          textAlign: align,
        }}
      >
        Explore
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: align === "start" ? "flex-start" : "center",
          gap: 1,
        }}
      >
        {links.map((link) => (
          <Chip
            key={link.path}
            component={RouterLink}
            to={link.path}
            clickable
            icon={<link.icon sx={{ fontSize: "16px !important" }} />}
            label={link.label}
            variant="outlined"
            sx={{
              borderRadius: 2,
              fontWeight: 500,
              "&:hover": {
                bgcolor: "action.hover",
                borderColor: "primary.main",
              },
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default HomeQuickLinks;
